module.exports = __webpack_public_path__ + "img/MedalOfHonour.c4b77ba1.jpg";